module.exports = __webpack_public_path__ + "static/media/avaya.c50679a2.png";